var styles = {"footer":"VDS__MON__modal-footer-module__IeG-h"};

export { styles as default };
